import React, { useState } from "react";
import { translate } from "../../../../../common/providers";
import { CustomTextField } from "../../../../../common/components";

export default function DescriptionCell({ data, isAuthor, updateDescription, onFocus = null }) {
	const [description, setDesription] = useState(data.description);
	const handleChange = (e) => {
		setDesription(e.target.value);
	};
	const handleSubmit = () => {
		updateDescription({ description, taskId: data.taskId });
	};
	return (
		<CustomTextField
			fullWidth
			multiline
			disabled={!isAuthor}
			id="outlined-flexible"
			maxRows={10}
			placeholder={translate("dashboards.task-dashboard.description")}
			value={description || ""}
			variant="outlined"
			onBlur={handleSubmit}
			onChange={handleChange}
			onFocus={onFocus}
		/>
	);
}
